<template>
  <div>
    <div>
      <MultiLineChart
        :legendHeaders="headers"
        :data="graphData"
        highLightColValue="1"
        :intervalTime="intervalTime"
        :chartId="`chart-1`"
        :title="$t('top-applications-response-time')"
        @openModal="openGraphModal"
        :loading="false"
        :graphIndex="0"
        :formula="(e) => Number(e).toFixed(1)"
        :animations="true"
        :Graphlabels="{ x: $t('time'), y: $t('responseTimeWithUnit') }"
      />
    </div>
    <MultiChartModal
      :legendHeaders="headers"
      :data="graphData"
      highLightColValue="1"
      :intervalTime="intervalTime"
      :showGraphModal="showGraphModal"
      @onHide="showGraphModal = false"
      chartId="2dasd"
      infoSpanColIndex="0"
      :title="$t('top-applications-response-time')"
      @closeGraphModal="showGraphModal = false"
      :formula="(e) => Number(e).toFixed(1)"
      :Graphlabels="{ x: $t('time'), y: $t('responseTimeWithUnit') }"
    />
  </div>
</template>
<script>
import MultiLineChart from '@/components/charts/multi-chart';
import MultiChartModal from '@/components/charts/multi-chart-modal';
import graphQl from '@/services/graphQl';
import { mapGetters } from 'vuex';
import { TOP_APPS_RES_HEADERS } from './util';
export default {
  components: { MultiLineChart, MultiChartModal },
  name: 'TopResponsetimeApps',
  data() {
    return {
      graphData: [],
      showGraphModal: false,
    };
  },
  methods: {
    async getData() {
      try {
        const params = {
          duration: this.getDurationTime,
          condition: {
            entity: {
              scope: 'All',
            },
          },
        };
        const {
          data: {
            data: {
              getTopAppByRespTime: { response },
            },
          },
        } = await graphQl.query('queryTopAppByRespTime').params(params);

        this.graphData = response.map((ele) => {
          let newValue = {};
          newValue.label = ele.serviceName;
          newValue.serviceId = ele.serviceId;
          newValue.capability = ele.capability;
          if (newValue.capability === 'A') {
            newValue.redirect = {
              name: 'apm',
              query: {
                id: ele.serviceId,
              },
            };
          } else if (newValue.capability === 'M') {
            newValue.redirect = {
              name: 'mobile',
              query: {
                id: ele.serviceId,
              },
            };
          }
          newValue.values = ele.values.values;
          if (ele.values.avg !== undefined) newValue.avg = ele.values.avg;
          return newValue;
        });
      } catch (error) {
        console.log('error', error);
      }
    },
    openGraphModal(index) {
      this.showGraphModal = true;
    },
  },
  watch: {
    getDurationTime(newValue) {
      this.getData();
    },
  },

  mounted() {
    this.getData();
  },
  computed: {
    ...mapGetters('globalState/settings', ['intervalTime', 'getDurationTime']),
    headers() {
      return TOP_APPS_RES_HEADERS();
    },
  },
};
</script>
<style scoped></style>
